module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/18-88740fa524bae214e6fe705da817dcf1.jpg";